/** @jsx jsx */
import { jsx } from "theme-ui";

const PublicHeader = () => {
  return <div sx={{ backgroundColor: "white", mb: 3 }} />;
};

export default PublicHeader;
